module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular03-a02530cf52f11e3f040f794738ae1eba.png";